export default "__VITE_ASSET__BDpi4l_k__"